import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SELECT_EXPORT_PAGES } from "@/Constants/common";
import {
  deSelectAllCandidate,
  updateCandidateStatus,
} from "@/reducers/client_candidates/candidatesworked";
import { toastMessageText } from "@/utilities/CommonText";

import { _exportWorkedCandidates } from "../../../../../../services/clientexport";
import ExportButton from "../../../ActionButtons/ExportButton";
import MarkAsPreferredButton from "../../../ActionButtons/MarkAsPreferredButton";
import { MarkAsUnsuitableButton } from "../../../ActionButtons/MarkAsUnsuitableButton";
import { RemoveStatusButton } from "../../../ActionButtons/RemoveStatusButton";

/**
 * Manages various actions related to candidate selection and approval.
 *
 * @param {Object} diffList - the list of differences
 * @param {Function} setDiffList - function to set the list of differences
 * @return {JSX.Element} The rendered React component
 */
export const Actions = ({ diffList, setDiffList }) => {
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const {
    selectedCandidate,
    pagination,
    workedCandidates,
    isSelectedAll,
    selectedContract,
    listView,
  } = useSelector((state) => state.clientCandidatesWorked);
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const [shortListLoading, setShortListLoading] = useState(false);
  const [unsuitableLoading, setUnsuitableLoading] = useState(false);
  const [removeStatusLoading, setRemoveStatusLoading] = useState(false);
  /**
   * Function to handle reloading the table.
   */
  const handleReloadTable = (
    unsuitable,
    sortlisted,
    isSelectedAll,
    ignoreIds,
    ids,
  ) => {
    dispatch(
      updateCandidateStatus({
        unsuitable,
        sortlisted,
        isSelectedAll,
        ignoreIds,
        ids,
      }),
    );
    dispatch(deSelectAllCandidate());
  };

  return (
    <>
      <div className="Actions_Wrapper tour-worked-actions">
        <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
          <MarkAsPreferredButton
            selectedCandidate={selectedCandidate}
            loading={shortListLoading}
            setLoading={setShortListLoading}
            deSelectAllCandidate={deSelectAllCandidate}
            page={SELECT_EXPORT_PAGES.WORKED}
            isSelectedAll={isSelectedAll}
            ignoreIds={
              isSelectedAll
                ? workedCandidates
                    .filter(
                      (ele) => !selectedContract.includes(ele.contract_id),
                    )
                    .map((ele) => ele.candidate_id)
                    .join(",")
                : ""
            }
            callback={handleReloadTable}
            emptyMarkAsPreferredMessage={toastMessageText.noCandidateSelected}
          />

          <RemoveStatusButton
            selectedCandidate={selectedCandidate}
            loading={removeStatusLoading}
            setLoading={setRemoveStatusLoading}
            deSelectAllCandidate={deSelectAllCandidate}
            page={SELECT_EXPORT_PAGES.WORKED}
            isSelectedAll={isSelectedAll}
            ignoreIds={
              isSelectedAll
                ? workedCandidates
                    .filter(
                      (ele) => !selectedContract.includes(ele.contract_id),
                    )
                    .map((ele) => ele.candidate_id)
                    .join(",")
                : ""
            }
            callback={handleReloadTable}
          />
          <MarkAsUnsuitableButton
            selectedCandidate={selectedCandidate}
            loading={unsuitableLoading}
            setLoading={setUnsuitableLoading}
            deSelectAllCandidate={deSelectAllCandidate}
            page={SELECT_EXPORT_PAGES.WORKED}
            isSelectedAll={isSelectedAll}
            ignoreIds={
              isSelectedAll
                ? workedCandidates
                    .filter(
                      (ele) => !selectedContract.includes(ele.contract_id),
                    )
                    .map((ele) => ele.candidate_id)
                    .join(",")
                : ""
            }
            callback={handleReloadTable}
          />

          <ExportButton
            page={SELECT_EXPORT_PAGES.WORKED}
            // exportUrl={routingConstants.exportWorked}
            isPrimary={true}
            exportFunction={_exportWorkedCandidates}
            selectedTablesData={selectedCandidate}
            ignoreIds={
              isSelectedAll
                ? workedCandidates
                    .filter(
                      (ele) => !selectedContract.includes(ele.contract_id),
                    )
                    .map((ele) => ele.contract_id)
                    .join(",")
                : ""
            }
            isSelectedAll={isSelectedAll}
            extraObj={{
              contract_ids: selectedContract.join(","),
            }}
            emptyExportMessage={toastMessageText.emptyExportMessageForContract}
          />
        </div>
      </div>
    </>
  );
};
